import {
  JSResource,
  type SimpleEntryPoint,
} from "@loop-payments/react-router-relay";
import type { UserPermissions } from "./UserPermissions";
import UserPermissionsQueryNode from "./__generated__/UserPermissionsQuery.graphql";

const entryPoint: SimpleEntryPoint<typeof UserPermissions> = {
  root: JSResource("UserPermissions", () =>
    import("./UserPermissions").then((module) => module.UserPermissions),
  ),
  getPreloadProps() {
    return {
      queries: {
        query: {
          parameters: UserPermissionsQueryNode,
          variables: {},
          options: {
            fetchPolicy: "store-and-network",
          },
        },
      },
    };
  },
};

export default entryPoint;
